import UserLayout from './UserLayout'
import BlankLayout from './BlankLayout'
import BasicLayout from './BasicLayout'
import RouteView from './RouteView'
import PageView from './PageView'

export { UserLayout, BasicLayout, BlankLayout, RouteView, PageView }
